export default __webpack_public_path__ + "static/media/0012.4dac7965.WAV";